"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionBuilderProvider = exports.useSessionBuilder = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const cleanGeneratedHtmlCode_1 = require("../utils/cleanGeneratedHtmlCode");
const promptHistoryApi_1 = require("../api/promptHistoryApi");
const sessionBuilder_1 = require("../api/sessionBuilder");
const SessionContext_1 = require("./SessionContext");
const SessionBuilderContext = (0, react_1.createContext)(undefined);
const useSessionBuilder = () => {
    const ctx = (0, react_1.useContext)(SessionBuilderContext);
    if (!ctx) {
        throw new Error("useSessionBuilder must be used within a SessionBuilderProvider");
    }
    return ctx;
};
exports.useSessionBuilder = useSessionBuilder;
const SessionBuilderProvider = ({ sessionId, docType, children, newTemplateGenerate = false, }) => {
    const { session, loading, setSession, isNewSession } = (0, SessionContext_1.useSession)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const [generatedCode, setGeneratedCode] = (0, react_1.useState)((session === null || session === void 0 ? void 0 : session.html) || "");
    const [status, setStatus] = (0, react_1.useState)("");
    const [error, setError] = (0, react_1.useState)("");
    const [isGenerating, setIsGenerating] = (0, react_1.useState)(false);
    const [conversation, setConversation] = (0, react_1.useState)([]);
    // Use a ref to track the current session ID to avoid stale closures
    const currentSessionIdRef = react_1.default.useRef(session === null || session === void 0 ? void 0 : session.id);
    // Update ref whenever session changes
    react_1.default.useEffect(() => {
        if (session === null || session === void 0 ? void 0 : session.id) {
            currentSessionIdRef.current = session.id;
        }
    }, [session === null || session === void 0 ? void 0 : session.id]);
    react_1.default.useEffect(() => {
        // Skip loading history for new sessions
        if (!sessionId || isNewSession)
            return;
        (0, promptHistoryApi_1.getAllPromptHistory)(sessionId)
            .then((history) => {
            console.log(history);
            const formatted = history.map((item) => ({
                id: item.id,
                prompt: item.prompt,
                aiResponseHtml: item.aiResponseHtml,
                isLoading: !item.aiResponseHtml,
            }));
            setConversation(formatted);
            console.log("generatedCode outer", generatedCode);
            if (generatedCode === "" && formatted.length > 0) {
                const lastItem = formatted[formatted.length - 1];
                setGeneratedCode(lastItem.aiResponseHtml || "");
                console.log("generatedCode", lastItem.aiResponseHtml || "");
            }
        })
            .catch((err) => {
            setError("Failed to load conversation history");
            console.error(err);
        });
    }, [sessionId, isNewSession]);
    const handlePromptSend = (0, react_1.useCallback)((prompt) => __awaiter(void 0, void 0, void 0, function* () {
        // If this is a new session, create it first
        if (isNewSession && docType && session) {
            try {
                console.log("🆕 Creating new session for docType:", docType);
                // Extract first few words from prompt for session name
                const words = prompt.trim().split(/\s+/).slice(0, 5).join(' ');
                const sessionName = words || "New Session";
                // Create the session
                const newSession = yield (0, sessionBuilder_1.createSession)(docType, undefined, undefined, newTemplateGenerate ? true : false);
                console.log("✅ Session created with ID:", newSession.id);
                // Update the session name on the backend
                const updatedSession = yield (0, sessionBuilder_1.updateSession)(newSession.id, Object.assign(Object.assign({}, newSession), { name: sessionName }));
                console.log("✅ Session name updated to:", sessionName);
                // Update the ref immediately so it's available in handleCodeGenerated
                currentSessionIdRef.current = updatedSession.id;
                setSession(updatedSession);
                // Replace the URL without causing a page reload/remount
                // This prevents the WebSocket connection from being interrupted
                if (!newTemplateGenerate) {
                    const newUrl = `/${newSession.id}/form-builder`;
                    window.history.replaceState(null, '', newUrl);
                }
                // console.log("🔄 URL updated to:", newUrl);
                // Add the prompt to conversation
                const tempId = `temp-${Date.now()}`;
                setConversation((prev) => [
                    ...prev,
                    { id: tempId, prompt, aiResponseHtml: null, isLoading: true },
                ]);
                return;
            }
            catch (err) {
                console.error("❌ Failed to create session:", err);
                setError("Failed to create session");
                return;
            }
        }
        // For existing sessions, just add the prompt to conversation
        const tempId = `temp-${Date.now()}`;
        setConversation((prev) => [
            ...prev,
            { id: tempId, prompt, aiResponseHtml: null, isLoading: true },
        ]);
    }), [isNewSession, docType, session, setSession]);
    const handleCodeGenerated = (0, react_1.useCallback)((code) => {
        const cleaned = (0, cleanGeneratedHtmlCode_1.cleanGeneratedHtmlCode)(code);
        setGeneratedCode(cleaned);
        setIsGenerating(false);
        setError("");
        // if (cleaned && cleaned.trim()) {
        //   schemaManager.extractSchema(cleaned, {
        //     name: "Generated Form",
        //     description: "Form generated from AI prompt",
        //     prompt: "AI generated form",
        //   });
        // }
        setConversation((prev) => {
            const lastMsg = [...prev].reverse().find((msg) => msg.isLoading);
            if (lastMsg && currentSessionIdRef.current) {
                // Use the ref to get the most up-to-date session ID
                const actualSessionId = currentSessionIdRef.current;
                console.log("💾 Saving prompt history for session:", actualSessionId);
                (0, promptHistoryApi_1.createPromptHistory)(actualSessionId, lastMsg.prompt, cleaned)
                    .then((saved) => {
                    console.log("✅ Prompt history saved successfully:", saved.id);
                    setConversation((prev2) => prev2.map((msg) => msg.id === lastMsg.id
                        ? Object.assign(Object.assign({}, msg), { id: saved.id, prompt: saved.prompt, aiResponseHtml: saved.aiResponseHtml, isLoading: false }) : msg));
                })
                    .catch((err) => {
                    console.error("❌ Failed to save prompt history:", err);
                    setError("Failed to save prompt history");
                });
            }
            return prev;
        });
    }, 
    // Using empty deps because we're using refs, which don't need to be in deps
    []);
    const handleError = (error) => {
        setError(error);
        setIsGenerating(false);
        console.error("❌ Error occurred:", error);
    };
    const handleStatusUpdate = (statusUpdate) => {
        setStatus(statusUpdate);
        if (statusUpdate.includes("Starting")) {
            setIsGenerating(true);
        }
        console.log("📊 Status update:", statusUpdate);
    };
    const handleAiResponseClick = (0, react_1.useCallback)((html) => {
        if (html) {
            const cleaned = (0, cleanGeneratedHtmlCode_1.cleanGeneratedHtmlCode)(html);
            setGeneratedCode(cleaned);
            // if (cleaned && cleaned.trim()) {
            //   schemaManager.extractSchema(cleaned, {
            //     name: "Generated Form",
            //     description: "Form generated from AI prompt",
            //     prompt: "AI generated form",
            //   });
            // }
        }
    }, 
    // [schemaManager.extractSchema]
    []);
    return ((0, jsx_runtime_1.jsx)(SessionBuilderContext.Provider, { value: {
            generatedCode: generatedCode,
            setGeneratedCode,
            status,
            setStatus,
            error,
            setError,
            isGenerating,
            setIsGenerating,
            conversation,
            setConversation,
            handlePromptSend,
            handleCodeGenerated,
            handleError,
            handleStatusUpdate,
            handleAiResponseClick,
            // setCurrentSchema,
        }, children: children }));
};
exports.SessionBuilderProvider = SessionBuilderProvider;
